import { useEffect, useState } from 'react';

import type { IChangePasswordRequest } from '@treneo/models';

import {
  changePassword,
  clearChangePasswordError,
  clearIsChangePasswordSuccess,
  useSelectChangePasswordError,
  useSelectIsChangePasswordSuccess
} from '../../data';

import { ChangePasswordForm } from './change-password-form';

type Props = {
  onClose: () => void;
};

export const ChangePasswordFormContainer = ({ onClose }: Readonly<Props>) => {
  const changePasswordError = useSelectChangePasswordError();
  const isChangePasswordSuccess = useSelectIsChangePasswordSuccess();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values: IChangePasswordRequest) => {
    setIsLoading(true);
    try {
      await changePassword(values);
    } catch {
      void 0;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    clearChangePasswordError();
    clearIsChangePasswordSuccess();
  }, []);

  return (
    <ChangePasswordForm
      onSubmit={handleSubmit}
      onCancel={onClose}
      error={changePasswordError as string | null}
      isSubmitSuccess={isChangePasswordSuccess as boolean}
      isLoading={isLoading}
    />
  );
};
